"use strict";

// ---------------------------------------------------
// Load Super Class

var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Module Definition

/**
 * @class Condition
 * @extends SoaModel
 */
var Condition = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Condition.prototype, {

    /**
     *
     * @param {string} type
     * @returns {boolean}
     */
    hasCondition: function (type) {
        return this.get(type) === 'Y';
    },

    /**
     * @returns {boolean}
     */
    hasAnyWearDamage: function () {
        var wearType;
        for (wearType in Condition.WEAR) {
            if (this.hasCondition(Condition.WEAR[wearType])) {
                return true;
            }
        }

        return false;
    }

});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Condition, {
    STATE: {
        ART_EXCELLENT: 'EXCELLENT',
        ART_GOOD: 'GOOD',
        ART_FAIR: 'FAIR',
        FURNITURE_EXCELLENT: 'EXCELLENT',
        FURNITURE_GOOD: 'GOOD',
        FURNITURE_FAIR: 'FAIR',
        FURNITURE_DISTRESSED: 'DISTRESSED',
        JEWELRY_AS_NEW_WITH_BOX: 'AS_NEW_WITH_BOX',
        JEWELRY_AS_NEW: 'AS_NEW',
        JEWELRY_EXCELLENT: 'EXCELLENT',
        JEWELRY_GOOD: 'GOOD',
        JEWELRY_FAIR: 'FAIR',
        FASHION_NEW_NEVER_WORN: 'NEW_NEVER_WORN',
        FASHION_EXCELLENT: 'EXCELLENT',
        FASHION_GOOD: 'GOOD',
        FASHION_FAIR: 'FAIR'
    },

    WEAR: {
        DAMAGE_LIGHT: 'damageLight',
        DAMAGE_DESIGNER_ALTERED: 'damageDesignerAltered',
        DAMAGE_OTHER_ALTERED: 'damageOtherAltered',
        DAMAGE_LOSSES: 'damageLosses',
        DAMAGE_SOUND: 'damageSound',
        DAMAGE_FADING: 'damageFading',
        DAMAGE_RESTORED: 'damageRestored',
        DAMAGE_SERVICED: 'damageServiced'
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Condition.js
// module id = 2043
// module chunks = 62